import { render, staticRenderFns } from "./DashboardBilling.vue?vue&type=template&id=1ffc21da&scoped=true&"
import script from "./DashboardBilling.vue?vue&type=script&lang=js&"
export * from "./DashboardBilling.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBilling.vue?vue&type=style&index=0&id=1ffc21da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc21da",
  null
  
)

export default component.exports